export const pathologyTags = {
  ACT_LIST: 'ACT_LIST',
  ACT: 'ACT',
  ACT_AUDIO: 'ACT_AUDIO',
};
